/**
 * The token an emailed link carries, read the way the link carries it.
 *
 * tricorder-users puts purpose tokens in the URL FRAGMENT (rule 8 of the users
 * design): everything after "#" is never sent to a server, so the token stays
 * out of server logs, Referer headers and proxy access records. The query
 * string is read as a fallback for links minted the old way (care-app's own
 * emails used ?token= before the cut-over) and for hand-shared URLs — a token
 * in either place proves the same link.
 */
export function tokenFromLocation(): string {
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash
  const fromHash = new URLSearchParams(hash).get('token')
  if (fromHash !== null && fromHash !== '') return fromHash
  return new URLSearchParams(window.location.search).get('token') ?? ''
}
